export const NETWORK_OFFLINE = "NETWORK_OFFLINE";
export const OFFLINE_MESSAGE =
  "You are offline. Your data is safe on this device — reconnect to continue.";

export const isOffline = (nav) => {
  const target = nav === undefined ? (typeof navigator === "undefined" ? null : navigator) : nav;
  return Boolean(target && target.onLine === false);
};

export const onNetworkOnline = (handler, target) => {
  const scope = target === undefined ? (typeof window === "undefined" ? null : window) : target;
  if (!scope || typeof handler !== "function") return () => {};
  scope.addEventListener("online", handler);
  return () => scope.removeEventListener("online", handler);
};
